import React from 'react';
import { overrideLabel } from './reviewLabels';

const OPTIONS = [
  { value: 'keep', label: 'Confirm as is' },
  { value: 'set_heading:1', label: 'Heading 1' },
  { value: 'set_heading:2', label: 'Heading 2' },
  { value: 'set_heading:3', label: 'Heading 3' },
  { value: 'set_heading:4', label: 'Heading 4' },
  { value: 'set_body', label: 'Body text' },
  { value: 'set_caption', label: 'Caption' },
  { value: 'set_callout', label: 'Callout / key finding' },
  { value: 'exclude', label: 'Exclude from output' },
];

/** Compact "Mark as…" control. onApply({ block_key, action, level }) */
const BlockActions = ({ block, onApply, busy }) => {
  const current = block.override;
  const handleChange = (e) => {
    const [action, level] = e.target.value.split(':');
    e.target.value = '';
    if (!action) return;
    onApply({ block_key: block.block_key, action, level: level ? Number(level) : undefined });
  };

  return (
    <span className="dd-block-actions" onClick={(e) => e.stopPropagation()} role="presentation">
      {current && (
        <span className="dd-override-pill" title={current.note || `Set by ${current.updated_by || 'reviewer'}`}>
          {overrideLabel(current)}
          <button
            type="button"
            onClick={() => onApply({ block_key: block.block_key, action: 'clear' })}
            disabled={busy}
            aria-label="Clear override"
          >
            ×
          </button>
        </span>
      )}
      <select defaultValue="" onChange={handleChange} disabled={busy} aria-label="Mark block as">
        <option value="" disabled>Mark as…</option>
        {OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </span>
  );
};

export default BlockActions;
